import { useDispatch, useSelector } from "react-redux";
import Modal from "../UI/Modal";
import { closeFormModal, openViewModal } from "../../store/reducers/preguntasConfirmacion/preguntasConfirmacion.reducer";
import { useEffect, useState } from "react";
import {
  updatePreguntaConfirmacionThunk,
  getPreguntasConfirmacionThunk,
  getPreguntaConfirmacionByIdThunk,
} from "../../store/reducers/preguntasConfirmacion/preguntasConfirmacion.thunks";
import Loader from "../UI/Loader";
import Alert from "../UI/Alert";
import { toast } from "react-toastify";

const PreguntaConfirmacionFormModal = () => {
  const dispatch = useDispatch();
  const {
    formModalOpen,
    selectedPregunta,
    formLoading,
    formError,
    page,
    search,
  } = useSelector((state) => state.preguntasConfirmacion);

  const [formData, setFormData] = useState({
    pregunta: "",
  });

  useEffect(() => {
    if (selectedPregunta) {
      setFormData({
        pregunta: selectedPregunta.pregunta || "",
      });
    }
  }, [selectedPregunta, formModalOpen]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const result = await dispatch(
      updatePreguntaConfirmacionThunk({
        id: selectedPregunta.id,
        payload: formData,
      })
    );

    if (result.meta.requestStatus === "fulfilled") {
      dispatch(getPreguntasConfirmacionThunk({ page, search }));
      toast.success("Pregunta actualizada exitosamente");
      // Abrir modal de vista con el registro actualizado
      await dispatch(getPreguntaConfirmacionByIdThunk(selectedPregunta.id));
      dispatch(openViewModal());
    }
  };

  return (
    <Modal
      open={formModalOpen}
      onClose={() => dispatch(closeFormModal())}
      title="Editar pregunta"
      size="lg"
    >
      {formLoading ? (
        <Loader
          center
          type="dots"
          text="Actualizando pregunta..."
        />
      ) : (
        <form onSubmit={handleSubmit}>
          {formError && <Alert message={formError} variant="error" />}

          <div className="mb-3">
            <label className="form-label fw-medium">
              Pregunta <span className="text-danger">*</span>
            </label>
            <textarea
              className="form-control"
              name="pregunta"
              value={formData.pregunta}
              onChange={handleChange}
              placeholder="Ingrese la pregunta"
              rows="4"
              required
            />
          </div>

          <div className="d-flex justify-content-end gap-2">
            <button
              type="button"
              className="btn btn-secondary"
              onClick={() => dispatch(closeFormModal())}
            >
              Cancelar
            </button>

            <button type="submit" className="btn btn-primary">
              Guardar cambios
            </button>
          </div>
        </form>
      )}
    </Modal>
  );
};

export default PreguntaConfirmacionFormModal;
